import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import '@/styles/index.css';
import dayjs from 'dayjs';
import 'dayjs/locale/es-mx.js';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { GlobalProvider } from '@/store/Context.tsx';
import { ConfigurationProvider } from '@/store/configuration/Context.tsx';
import { TooltipProvider } from './components/ui/tooltip.tsx';
import { ENABLE_AUDIT_TRACKING } from './core/tracking/tracking.config.ts';
import { trackingService } from './core/tracking/tracking.service.ts';
import { queryClient } from './shared/infrastructure/query-clien.ts';

dayjs.locale('es-mx');

trackingService.init({
  endpoint: '/audit/front-event',
  enabled: ENABLE_AUDIT_TRACKING,
});

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <GlobalProvider>
      <ConfigurationProvider>
        <BrowserRouter>
          <TooltipProvider>
            <App />
          </TooltipProvider>
        </BrowserRouter>
      </ConfigurationProvider>
    </GlobalProvider>
  </QueryClientProvider>
);
